import Validator from "js-object-validation";
import { message } from "../common";

export const roleValidator = (data) => {
  const validations = {
    roleName: {
      required: true,
    },
  };
  // Error messages
  const messages = {
    roleName: {
      required: message.Required.replace(":item", "Role Name"),
    },
  };

  const { isValid, errors } = Validator(data, validations, messages);
  return {
    isValid,
    errors,
  };
};
